<script>
    export default {
        props: {
            refreshing: Boolean
        },
        computed: {
            tRefresh() {
                return Lang.langGet("Refresh Screenshots");
            }
        }
    }
</script>

<template>
    <v-btn type="button" class="btn btn-secondary mb-4" @click.stop.prevent="$emit('click')">
        <i v-if="refreshing" class="fa-regular fa-spinner fa-spin-pulse fa-fw m-r-xs"/>
        <i v-else class="fa-regular fa-arrows-rotate fa-fw m-r-xs"/>
        {{ tRefresh }}
    </v-btn>
</template>
